import { FolderSharingLinkKey } from "./key";
import { SimpleQueryOptions, useBaseQuery } from "../baseQuery";
import { GetFolderSharingLinkRequest, GetFolderSharingLinkResponse } from "@maven-rest/docs/FolderSharingLink.dto";
import { FolderSharingLinkUrl } from "@maven-rest/docs/FolderSharingLink.url";

export function useFolderSharingLinkQuery(
  req: GetFolderSharingLinkRequest,
  options?: SimpleQueryOptions<GetFolderSharingLinkResponse, GetFolderSharingLinkRequest>
) {
  return useBaseQuery({
    queryKey: [FolderSharingLinkKey.FolderSharingLink, String(req.organizationId), String(req.folderId), String(req.fileId)],
    fnOption: {
      url: FolderSharingLinkUrl.getFolderSharingLink,
      request: req,
    },
    ...options,
  });
}
